import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Worksbeach() {
  return (
    <section className="works_beach p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#000" }}>how it works</h2>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={3}
            xl={3}
            xxl={3}
            className="my-auto text-center"
          >
            <div className="works_img  mb-2">
              <StaticImage
                src="../../../images/case-studies/beach-bandits/1.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={236}
                height={217}
              />
            </div>
            <h5 style={{ color: "#92969C" }}>Sign Up</h5>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={3}
            xl={3}
            xxl={3}
            className="my-auto text-center"
          >
            <div className="works_img mb-2">
              <StaticImage
                src="../../../images/case-studies/beach-bandits/2.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={236}
                height={217}
              />
            </div>
            <h5 style={{ color: "#92969C" }}>Select Item</h5>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={3}
            xl={3}
            xxl={3}
            className="my-auto text-center"
          >
            <div className="works_img  mb-2">
              <StaticImage
                src="../../../images/case-studies/beach-bandits/3.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={236}
                height={217}
              />
            </div>
            <h5 style={{ color: "#92969C" }}>Check Out</h5>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={3}
            xl={3}
            xxl={3}
            className="my-auto text-center"
          >
            <div className="works_img  mb-2">
              <StaticImage
                src="../../../images/case-studies/beach-bandits/4.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={236}
                height={217}
              />
            </div>
            <h5 style={{ color: "#92969C" }}>Track Order</h5>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Worksbeach;
